import { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField, { InputPassword } from '../../../../utils/InputField';
import { handleSmtpConfigOpe } from '../BasicOperation';

function AddSmtpConfigModal({ closeModalHandler, handleReload }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const { setMessage } = useTemplate();
    // --handler to set input value to state
    const handleChange = (e) => {
        const { name, value: val } = e.target;
        if (name) {
            setFormData((prevData) => ({ ...prevData, [name]: val }));
        }
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);
        handleSmtpConfigOpe(formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                handleReload();
                closeModalHandler();
                setFormData({});
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error?.toString(0) });
            });
    };
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleSave}>
            <div className="flex flex-col gap-y-2 mb-4">
                <InputField
                    label="Hostname"
                    name="HostName"
                    placeholder="Type Hostname..."
                    formData={formData}
                    onChange={handleChange}
                />
                <InputField
                    label="Port"
                    name="Port"
                    placeholder="Type Port..."
                    formData={formData}
                    onChange={handleChange}
                />
                <InputField
                    label="Username"
                    name="Username"
                    placeholder="Type Username..."
                    formData={formData}
                    onChange={handleChange}
                />
                <InputPassword
                    label="Password"
                    name="Password"
                    placeholder="Type Password..."
                    formData={formData}
                    onChange={handleChange}
                />
            </div>

            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={() => closeModalHandler()} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default AddSmtpConfigModal;
